// Product Gallery Slider - Système de slider simple et fonctionnel
(function() {
  'use strict';

  // Fonction pour normaliser les chaînes (enlever accents, espaces, minuscules)
  function normalizeString(str) {
    if (!str) return '';
    return str.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Fonction pour vérifier si une chaîne correspond à une saveur
  function matchesFlavor(mediaAlt, selectedFlavor) {
    if (!selectedFlavor || !mediaAlt) return false;
    const normalizedAlt = normalizeString(mediaAlt);
    const normalizedFlavor = normalizeString(selectedFlavor);
    return normalizedAlt === normalizedFlavor || normalizedAlt.includes(normalizedFlavor) || normalizedFlavor.includes(normalizedAlt);
  }

  // Classe Slider simple
  class ProductGallerySlider {
    constructor(container, options = {}) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.gallery-slide'));
      this.currentIndex = 0;
      this.sectionId = options.sectionId || '';
      this.selectedFlavor = null;
      
      this.init();
    }

    init() {
      if (this.slides.length === 0) return;
      
      // Créer la structure du slider
      this.createSliderStructure();
      
      // Initialiser les événements
      this.initEvents();
      
      // Afficher le premier slide
      this.showSlide(0);
      
      console.log('✅ Slider initialisé avec', this.slides.length, 'slides');
    }

    createSliderStructure() {
      // Créer le conteneur du slider
      const sliderContainer = document.createElement('div');
      sliderContainer.className = 'gallery-slider-container';
      sliderContainer.style.cssText = 'position: relative; width: 100%; overflow: hidden;';
      
      // Créer le wrapper des slides
      const slidesWrapper = document.createElement('div');
      slidesWrapper.className = 'gallery-slides-wrapper';
      slidesWrapper.style.cssText = 'display: flex; transition: transform 0.3s ease; width: ' + (this.slides.length * 100) + '%;';
      
      // Déplacer les slides dans le wrapper
      this.slides.forEach((slide, index) => {
        const slideWrapper = document.createElement('div');
        slideWrapper.className = 'gallery-slide-wrapper';
        slideWrapper.style.cssText = 'width: ' + (100 / this.slides.length) + '%; flex-shrink: 0;';
        slideWrapper.appendChild(slide);
        slidesWrapper.appendChild(slideWrapper);
      });
      
      sliderContainer.appendChild(slidesWrapper);
      this.container.appendChild(sliderContainer);
      
      this.sliderContainer = sliderContainer;
      this.slidesWrapper = slidesWrapper;
      this.slideWrappers = Array.from(slidesWrapper.querySelectorAll('.gallery-slide-wrapper'));
    }

    showSlide(index) {
      if (index < 0 || index >= this.slideWrappers.length) return;
      
      // Vérifier que le slide est visible
      if (this.slideWrappers[index].style.display === 'none') {
        console.warn('⚠️ Tentative d\'afficher un slide masqué:', index);
        return;
      }
      
      // Compter les slides visibles avant l'index actuel
      let visibleBefore = 0;
      for (let i = 0; i < index; i++) {
        if (this.slideWrappers[i].style.display !== 'none') {
          visibleBefore++;
        }
      }
      
      const visibleSlides = this.slideWrappers.filter(w => w.style.display !== 'none').length;
      const slideWidth = visibleSlides > 0 ? (100 / visibleSlides) : 0;
      const translateX = -(visibleBefore * slideWidth);
      
      this.currentIndex = index;
      this.slidesWrapper.style.transform = 'translateX(' + translateX + '%)';
      
      // Mettre à jour les classes actives
      this.slideWrappers.forEach((wrapper, i) => {
        if (i === index) {
          wrapper.classList.add('active');
        } else {
          wrapper.classList.remove('active');
        }
      });
      
      // Mettre à jour les thumbnails
      this.updateThumbnails(index);
    }

    next() {
      // Trouver le prochain slide visible
      let nextIndex = this.currentIndex + 1;
      while (nextIndex < this.slideWrappers.length) {
        if (this.slideWrappers[nextIndex].style.display !== 'none') {
          this.showSlide(nextIndex);
          return;
        }
        nextIndex++;
      }
      // Si on arrive à la fin, revenir au début
      const firstVisibleIndex = this.slideWrappers.findIndex(w => w.style.display !== 'none');
      if (firstVisibleIndex !== -1) {
        this.showSlide(firstVisibleIndex);
      }
    }

    prev() {
      // Trouver le slide visible précédent
      let prevIndex = this.currentIndex - 1;
      while (prevIndex >= 0) {
        if (this.slideWrappers[prevIndex].style.display !== 'none') {
          this.showSlide(prevIndex);
          return;
        }
        prevIndex--;
      }
      // Si on arrive au début, aller à la fin
      for (let i = this.slideWrappers.length - 1; i >= 0; i--) {
        if (this.slideWrappers[i].style.display !== 'none') {
          this.showSlide(i);
          return;
        }
      }
    }

    goTo(index) {
      this.showSlide(index);
    }

    updateThumbnails(activeIndex) {
      const gallery = this.container.closest('media-gallery');
      if (!gallery) return;
      
      const activeSlide = this.slides[activeIndex];
      if (!activeSlide) return;
      
      const mediaId = activeSlide.getAttribute('data-media-id');
      if (!mediaId) return;
      
      const thumbnails = gallery.querySelectorAll('.thumbnail-slide');
      thumbnails.forEach((thumb) => {
        const target = thumb.getAttribute('data-target');
        if (target === mediaId) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });
    }

    filterByFlavor(flavor) {
      this.selectedFlavor = flavor;
      
      let visibleCount = 0;
      
      this.slideWrappers.forEach((wrapper, index) => {
        const slide = wrapper.querySelector('.gallery-slide');
        if (!slide) return;
        
        const mediaAlt = slide.getAttribute('data-alt') || '';
        const isFirstSlide = index === 0;
        const matchesFlavorValue = flavor && matchesFlavor(mediaAlt, flavor);
        const isAlwaysDisplay = mediaAlt === 'always_display';
        const noFilter = !flavor;
        
        const shouldShow = isFirstSlide || matchesFlavorValue || isAlwaysDisplay || noFilter;
        
        if (shouldShow) {
          wrapper.style.display = '';
          slide.classList.remove('hidden-by-flavor');
          visibleCount++;
        } else {
          wrapper.style.display = 'none';
          slide.classList.add('hidden-by-flavor');
        }
      });
      
      // Recalculer la largeur du wrapper seulement si nécessaire
      if (visibleCount > 0) {
        this.slidesWrapper.style.width = (visibleCount * 100) + '%';
        this.slideWrappers.forEach(wrapper => {
          if (wrapper.style.display !== 'none') {
            wrapper.style.width = (100 / visibleCount) + '%';
          }
        });
        
        // Vérifier si le slide actuel est toujours visible
        const currentWrapper = this.slideWrappers[this.currentIndex];
        if (currentWrapper && currentWrapper.style.display === 'none') {
          // Aller au premier slide visible
          const firstVisibleIndex = this.slideWrappers.findIndex(w => w.style.display !== 'none');
          if (firstVisibleIndex !== -1) {
            this.showSlide(firstVisibleIndex);
          }
        } else {
          // Mettre à jour l'affichage du slide actuel
          this.showSlide(this.currentIndex);
        }
      }
      
      // Filtrer aussi les thumbnails
      this.filterThumbnails(flavor);
      
      console.log('🎨 Filtrage appliqué - Saveur:', flavor || 'Aucune', 'Slides visibles:', visibleCount);
    }

    filterThumbnails(flavor) {
      const gallery = this.container.closest('media-gallery');
      if (!gallery) return;
      
      const thumbnails = gallery.querySelectorAll('.thumbnail-slide');
      thumbnails.forEach((thumb, index) => {
        const thumbAlt = thumb.getAttribute('data-alt') || '';
        const isFirstThumbnail = index === 0;
        const matchesFlavorValue = flavor && matchesFlavor(thumbAlt, flavor);
        const isAlwaysDisplay = thumbAlt === 'always_display';
        const noFilter = !flavor;
        
        const shouldShow = isFirstThumbnail || matchesFlavorValue || isAlwaysDisplay || noFilter;
        
        if (shouldShow) {
          thumb.style.display = '';
          thumb.classList.remove('hidden-by-flavor');
        } else {
          thumb.style.display = 'none';
          thumb.classList.add('hidden-by-flavor');
        }
      });
    }

    initEvents() {
      // Navigation avec les boutons
      const nextBtn = this.container.parentElement.querySelector('.gallery-btn-next');
      const prevBtn = this.container.parentElement.querySelector('.gallery-btn-prev');
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => this.next());
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.prev());
      }
      
      // Navigation avec les thumbnails
      const gallery = this.container.closest('media-gallery');
      if (gallery) {
        const thumbnails = gallery.querySelectorAll('.thumbnail-slide');
        thumbnails.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const target = thumb.getAttribute('data-target');
            if (target) {
              const slideIndex = this.slides.findIndex(slide => slide.getAttribute('data-media-id') === target);
              if (slideIndex !== -1) {
                this.goTo(slideIndex);
              }
            }
          });
        });
      }
      
      // Navigation au clavier
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });
    }
  }

  // Initialiser tous les sliders
  function initAllSliders() {
    const galleries = document.querySelectorAll('media-gallery');
    
    galleries.forEach(gallery => {
      const sectionId = gallery.dataset.section;
      const slidesContainer = gallery.querySelector('.gallery-slides-container');
      
      if (slidesContainer && !slidesContainer.sliderInstance) {
        const slider = new ProductGallerySlider(slidesContainer, { sectionId });
        slidesContainer.sliderInstance = slider;
        
        // Stocker la référence dans la galerie
        gallery.sliderInstance = slider;
      }
    });
  }

  // Filtrage par saveur
  function setupFlavorFiltering() {
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"][data-flavor-radio]')) {
        const selectedFlavor = e.target.value;
        console.log('🍓 Saveur sélectionnée:', selectedFlavor);
        
        const galleries = document.querySelectorAll('media-gallery');
        galleries.forEach(gallery => {
          if (gallery.sliderInstance) {
            gallery.sliderInstance.filterByFlavor(selectedFlavor);
          }
        });
      }
    });
    
    // Initialiser avec la saveur déjà sélectionnée
    setTimeout(() => {
      const checkedFlavor = document.querySelector('input[type="radio"][data-flavor-radio]:checked');
      if (checkedFlavor) {
        const selectedFlavor = checkedFlavor.value;
        const galleries = document.querySelectorAll('media-gallery');
        galleries.forEach(gallery => {
          if (gallery.sliderInstance) {
            gallery.sliderInstance.filterByFlavor(selectedFlavor);
          }
        });
      }
    }, 500);
  }

  // Initialisation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAllSliders, 100);
      setTimeout(setupFlavorFiltering, 200);
    });
  } else {
    setTimeout(initAllSliders, 100);
    setTimeout(setupFlavorFiltering, 200);
  }

  // Réinitialiser lors du rechargement de sections Shopify
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initAllSliders, 100);
    });
  }
})();
